import { computed, Component, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { CookieConsentService } from '@services/cookie-consent.service'

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class CookieBannerComponent {
  private cookieConsentService = inject(CookieConsentService)
  readonly showBanner = computed(() => this.cookieConsentService.consent() === null)

  acceptAll(): void {
    this.cookieConsentService.accept()
  }

  acceptOnlyNecessary(): void {
    this.cookieConsentService.decline()
  }
}
